import React from 'react'
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import DateFormat from '../../../../../util/dateFormat'
import Text from '../../../../../uis/form/text';
import * as actions from '../reducers/list'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        textDecoration: 'underline',
        cursor: 'pointer'
    }
})
const validate = values => {
    const errors = {}
    if (!values.title) {
      errors.title = '必填'
    }
    if (!values.content) {
      errors.content = '必填'
    }
    return errors
}
const AddDialog = ({ classes,dispatch,showModal,pristine,submitting,handleSubmit }) => (
    <Dialog
        open={showModal.add}
        onClose={() => dispatch({type: actions.HIDE_MODAL})}
        fullWidth
    >
        <form onSubmit={handleSubmit} noValidate autoComplete="off">
            <DialogContent className={classes.dialogContent}>
                <Text name="title" label="标题" placeholder="标题" className={classes.textField} required={true} />
                <Text name="content" label="内容" placeholder="内容" className={classes.textField} required={true} />
            </DialogContent>
            <DialogActions className={classes.dislogActions}>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
            </DialogActions>
        </form>
    </Dialog> 
)
const AddFormDialog = reduxForm({
    form: 'noticeAddForm',
    validate
})(AddDialog)

const DeleteDialog = ({ dispatch,showModal }) => (
    <Dialog
        open={showModal.delete}
        onClose={() => dispatch({type: actions.HIDE_MODAL})}
        fullWidth
    >
        <DialogContent>确定删除吗？</DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
            <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
        </DialogActions>
    </Dialog>
)

const DetailDialog = ({ dispatch,showModal }) => (
    <Dialog
        open={showModal.detail}
        onClose={() => dispatch({type: actions.HIDE_MODAL})}
        fullWidth
    >
        <DialogTitle>公告详情</DialogTitle>
        <DialogContent>{showModal.content}</DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>确定</Button>
        </DialogActions>
    </Dialog>
)

class Notice extends React.Component {
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
    }
    render() {
        const {classes,dispatch,list,page,total,showModal,permissionMap} = this.props
        return (
            <div>
                {permissionMap['公告管理_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增公告</Button>}
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>时间</TableCell>
                                <TableCell>标题</TableCell>
                                <TableCell>内容</TableCell>
                                {permissionMap['公告管理_删除'] && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((row,index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{DateFormat(new Date(row.createTime),'yyyy-MM-dd HH:mm')}</TableCell>
                                        <TableCell>{row.title}</TableCell>
                                        <TableCell className={classes.contentCell} onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'detail',content: row.content})}>{row.content}</TableCell>
                                        {permissionMap['公告管理_删除'] && <TableCell>
                                            <Tooltip id="clear" title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete',id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
                {showModal.detail && <DetailDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.notice,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Notice))


// WEBPACK FOOTER //
// ./src/pages/home/routes/notice/components/list.js